import React from 'react';
import { NavLink } from 'react-router-dom';

const Tour = (props) => {
    const { _id, img, title, description, location, duration, price, rating } = props.tour;

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col h-full hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group">
            <div className="relative h-64 overflow-hidden">
                <img src={img} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" alt={title || "Tour"} />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-bold text-slate-900 shadow-sm flex items-center">
                    <i className="fas fa-star text-amber-500 mr-1"></i> {rating || "4.5"}
                </div>
                <div className="absolute bottom-4 left-4 bg-amber-500 text-slate-900 font-extrabold px-4 py-1 rounded-lg text-lg shadow-lg">
                    ${price || "999"}
                </div>
            </div>
            
            <div className="p-8 flex flex-col flex-grow">
                <div className="flex items-center text-amber-600 text-sm font-semibold mb-3 uppercase tracking-wider">
                    <i className="fas fa-map-marker-alt mr-2"></i> {location || "Global Destination"}
                </div>
                
                <h5 className="text-2xl font-bold text-slate-900 mb-4 line-clamp-1 group-hover:text-amber-500 transition-colors">{title}</h5>
                
                <p className="text-slate-600 mb-6 flex-grow line-clamp-2 leading-relaxed text-sm">
                    {description || "Explore the unseen beauty of the world with our exclusively curated premium travel packages."}
                </p>
                
                <div className="flex items-center justify-between mb-8 pb-6 border-b border-gray-100">
                    <div className="flex items-center text-slate-500 text-sm">
                        <i className="far fa-clock mr-2 text-amber-500"></i> {duration || "5 Days"}
                    </div>
                    <div className="flex items-center text-slate-500 text-sm">
                        <i className="fas fa-user-friends mr-2 text-amber-500"></i> Group / Private
                    </div>
                </div>
                
                <div className="mt-auto">
                    <NavLink
                        to={`/tourbooking/${_id}`}
                        className="block w-full text-center bg-slate-900 hover:bg-amber-500 text-white hover:text-slate-900 font-bold py-4 px-6 rounded-xl transition-all duration-300 shadow-lg hover:shadow-amber-500/20"
                    >
                        Book Expedition
                    </NavLink>
                </div>
            </div>
        </div>
    );
};

export default Tour;